/**
 * Centralized configuration for the Student App.
 */
export const AppConfig = {
    /**
     * The default server URL to fall back to if discovery fails.
     */
    DEFAULT_SERVER_URL: process.env.VITE_SYNC_SERVER_URL || 'http://localhost:4005',

    /**
     * The fixed production sync-server that hosts the demo class (join code ABC-123).
     * "Try Demo" always targets this host so a prospective user on a real device
     * reaches the known demo account regardless of how the app build was configured
     * — the demo must NOT fall back to localhost (which on a tablet is the device
     * itself and never has a sync-server listening). Override via VITE_DEMO_SERVER_URL
     * for local/staging testing.
     */
    DEMO_SERVER_URL: process.env.VITE_DEMO_SERVER_URL || 'https://sync.eduwrite.net',

    /**
     * DNS fallback hosts for when the primary custom domain fails to resolve
     * (e.g., stale negative cache on Android). Ordered by reliability.
     */
    DNS_FALLBACK_HOSTS: [
        'https://sync-server.blackocean-2ef33e81.uksouth.azurecontainerapps.io', // CNAME target
        'https://51.132.153.207',     // Direct IP (may change on redeploy)
    ],

    /**
     * Local network candidates for server discovery.
     * These are prioritized in local/dev environments.
     */
    DISCOVERY_CANDIDATES: [
        'http://proxy.local:4005',     // Local Proxy (mDNS)
        'http://10.0.2.2:4005',        // Emulator Bridge
        'http://localhost:4005',       // ADB Bridge
        'http://192.168.2.25',         // Primary Host LAN IP
        'http://10.0.2.2',             // Android Emulator Host
        'http://localhost'             // Localhost
    ],

    /**
     * Timeouts for discovery pings.
     */
    TIMEOUTS: {
        PRIMARY_PING: 10000,
        CANDIDATE_PING: 3000,
        DNS_RETRY_DELAY: 2000,        // ms to wait before retrying failed DNS
    }
};
